import "@awesome.me/kit-8f47e037be/icons/css/all.css";
import { createRoot } from "react-dom/client";
import App from "./app.js";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { store } from "./store.js";
import config from "devextreme/core/config";
import { licenseKey } from "../devextreme-license";

config({ licenseKey });

window.dojoConfig = {
  async: true,
  packages: [
    {
      name: "react",
      location: "https://unpkg.com/react@16/umd/",
      main: "react.production.min",
    },
    {
      name: "react-dom",
      location: "https://unpkg.com/react-dom@16/umd/",
      main: "react-dom.production.min",
    },
  ],
};

// this is required for devextreme file-uploader to work.
let open = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function () {
  open.apply(this, arguments);
  this.withCredentials = true;
};

const root = createRoot(document.getElementById("root"));
root.render(
  <Router>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>
);
